<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <h5 class="mb-5">Formas de Pagamento</h5>

          <div>
            <label for="" class="vs-select--label">Forma</label>
            <v-select
              :options="formasPagamentoApolice"
              name="Forma"
              id="Forma"
              v-model="form.idTipoPagamento"
              label="descricao"
              placeholder="Selecione"
              :reduce="(item) => item.idTipoPagamento"
              @input="emitChangedForm('idTipoPagamento', form.idTipoPagamento)"
            ></v-select>
          </div>

          <div v-if="form.idTipoPagamento">
            <label for="" class="vs-select--label"
              >Quantidade de Parcelas</label
            >
            <v-select
              :options="quantidadeParcelas"
              name="qtdParcelas"
              id="qtdParcelas"
              v-model="form.qtdParcelas"
              :reduce="(item) => item.id"
              label="value"
              placeholder="Selecione"
              @input="emitChangedForm('qtdParcelas', form.qtdParcelas)"
            ></v-select>
          </div>

          <div v-if="hasCartaoCredito">
            <vs-button color="success" @click="modalCreditCard = true"
              >+ Adicionar Cartão</vs-button
            >
            <div v-if="listCartoes.length == 0" class="mt-3 alert alert-danger">
              <vs-alert
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
                color="danger"
              >
                Nenhum Cartão Encontrado
              </vs-alert>
            </div>
            <div v-else class="mt-3 alert alert-info">
              <vs-alert
                title="Atenção!!"
                active="true"
                class="my-3"
                style="height: auto !important"
                color="primary"
              >
                Selecione um dos Cartões para continuar o Processo
              </vs-alert>
            </div>
            <ul class="centerx">
              <li
                v-for="item in listCartoes"
                :key="item.id"
                :class="`item-lista ${
                  item.selecionado == true ? 'bg-success' : ''
                }`"
              >
                {{ item.cardNumber }}
                <vs-chip color="primary mr-3">{{ item.bandeira }}</vs-chip>
              </li>
            </ul>
          </div>
        </div>

        <div class="vx-col sm:w-1/2 w-full mb-2 mt-10">
          <label for="" class="vs-select--label">Dia de Vencimento</label>
          <v-select
            :options="diasDeVencimentoEmpresa"
            name="diaVencimentoMensalidade"
            id="diaVencimentoMensalidade"
            v-model="form.diaVencimentoMensalidade"
            placeholder="Selecione"
            @input="
              emitChangedForm(
                'diaVencimentoMensalidade',
                form.diaVencimentoMensalidade,
              )
            "
          ></v-select>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import service from './../../services';
import functions from './../../utils/functions';
import notify from './../../utils/notify';
import utilsList from './../../utils/list';
import vSelect from 'vue-select';

export default {
  props: ['dadosProposta', 'produtosSelecionados', 'recarregaFinanceiro'],
  components: {
    'v-select': vSelect,
  },
  watch: {
    dadosProposta() {
      this.preencheForm();
      this.buscarFormasPagamentoApolice();
      this.buscaConfigEmpresa();
    },
    'form.idTipoPagamento': function (newValue) {
      if (!newValue || !this.formasPagamentoApolice.length) {
        return;
      }

      this.atribuirQuantidadeParcelas(newValue);
    },
  },
  computed: {},
  data() {
    return {
      diasDeVencimentoEmpresa: [],
      listaProdutosMensais: [],
      listaProdutosAAvista: [],
      hasCartaoCredito: false,
      jsonFacilitadorProdutos: [],
      produtos: [],
      produtosAtualizaModel: [],
      formasPagamentoApolice: [],
      quantidadeParcelas: [],
      form: {
        idAPolice: null,
        diaVencimentoMensalidade: null,
        qtdParcelas: null,
        idTipoPagamento: null,
      },
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
    };
  },
  methods: {
    emitChangedForm(id, value, formulario = 'dadosFinaneiros') {
      this.$emit('changed', { formulario, id, value, P4: true });
    },
    buscaConfigEmpresa() {
      try {
        service
          .getAll(
            'g',
            {},
            'empresas/list/idEmpresa/' + this.dadosProposta.idEmpresa,
          )
          .then((res) => {
            if (res.data[0].diasVencimento) {
              if (
                functions.verificaEmpresaBemProtege(
                  this.dadosProposta.idEmpresa,
                )
              ) {
                this.diasDeVencimentoEmpresa = this.optionsDiasVencimento(
                  res.data[0].diasVencimento,
                );
              } else {
                this.diasDeVencimentoEmpresa =
                  res.data[0].diasVencimento.split(',');
              }
            }
            if (res.data[0].qtdDiasVencimentoAvista) {
              this.qtdDiasVencimentoAvistaEmpresa =
                res.data[0].qtdDiasVencimentoAvista;
            }
          })
          .catch((e) => {
            notify.notifyFail(
              this.$vs,
              'Não foi possível buscar as configurasções da empresa, tente novamente.',
            );
          });
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Não foi possível buscar as configurasções da empresa, tente novamente.',
        );
      }
    },
    optionsDiasVencimento(arrayDiasVencimento) {
      const dataVistoria = new Date();
      const diaDoMesVistoria = dataVistoria.getDate();
      const arrStr = arrayDiasVencimento
        .split(',')
        .map(Number) // aqui converto o array de strings em numbers
        .sort((a, b) => a - b); // ordeno do menor para o maior
      if (diaDoMesVistoria >= 1 && diaDoMesVistoria <= 31) {
        const maxDay = Math.min(diaDoMesVistoria, 31); // seta o maxDay baseado no dia atual garantindo que seja menor que 31

        const novoArrayVencimento = arrStr.filter(
          (element) => element <= maxDay + 4 && maxDay - element <= 5,
        );
        if (diaDoMesVistoria >= 16) novoArrayVencimento.push(10);
        if (diaDoMesVistoria >= 21) novoArrayVencimento.push(15);
        if (diaDoMesVistoria >= 26) novoArrayVencimento.push(20);

        return novoArrayVencimento.sort((a, b) => a - b);
      }
    },
    preencheForm() {
      this.form.idAPolice = this.dadosProposta.idApolice;
      this.emitChangedForm('idAPolice', this.form.idAPolice);
      this.form.idTipoPagamento = this.dadosProposta.idTipoPagemento;
      this.form.qtdParcelas = this.dadosProposta.qtdParcelas;
      this.form.diaVencimentoMensalidade =
        this.dadosProposta.diaVencimentoMensalidade;

      this.emitChangedForm('idAPolice', this.form.idAPolice);
      this.emitChangedForm('idTipoPagamento', this.form.idTipoPagamento);
      this.emitChangedForm('qtdParcelas', this.form.qtdParcelas);
      this.emitChangedForm(
        'diaVencimentoMensalidade',
        this.form.diaVencimentoMensalidade,
      );
    },
    async buscarFormasPagamentoApolice() {
      try {
        this.$vs.loading();
        const { data: formas, cartoes } = await service.post(
          'Cotacao',
          'buscar-formas-paagamento-apolice',
          { idProposta: this.dadosProposta.idProposta },
        );

        this.formasPagamentoApolice = formas.formas;
        if (this.dadosProposta.idTipoPagemento) {
          this.atribuirQuantidadeParcelas(this.dadosProposta.idTipoPagemento);
        }
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    atribuirQuantidadeParcelas(idTipoPagamento) {
      const forma = this.formasPagamentoApolice.find(
        (f) => f.idTipoPagamento === idTipoPagamento,
      );

      const parcelas = forma.parcelas;
      this.quantidadeParcelas = Array.from(
        { length: parcelas },
        (_, index) => ({ id: index + 1, value: index + 1 }),
      );
    },
  },
  mounted() {},
  created() {},
};
</script>
<style scoped lang="scss">
.vdp-datepicker input {
  width: 100%;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary button:not(:disabled):hover {
  color: #fff !important;
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
